import { GetServerSideProps } from 'next';
import { eventsService } from '../../../services';
import { getInstanceOfEventByAlias, preloadEventData } from '../../[...params]';
import { EventType } from '../../../services/types/event-types';
import { checkUserAgentIsBot } from '../../../utils/checkUserAgentIsBot';
import { QueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../../constants';
import dynamic from 'next/dynamic';

const DynamicEventPage = dynamic(() => import('../../../components/pages/EventPage/event-page.component'));

export const getServerSideProps: GetServerSideProps = async (context) => {
	const { res } = context;
	const userAgent = context.req.headers['user-agent']
	const isBot = checkUserAgentIsBot(userAgent);

	const { eventAlias } = context.query as { eventAlias: string };

	const queryClient = new QueryClient();

	let event: EventType | undefined = undefined;

	if (eventAlias) {
		const { eventAlias: alias, shortLocalInstance } = await getInstanceOfEventByAlias(eventAlias);

		if (shortLocalInstance) {
			await queryClient.prefetchQuery(
				queryKeys.eventInstance(alias, shortLocalInstance),
				async () => eventsService.getPublicEventInstanceByAlias(alias, shortLocalInstance, '[eventAlias]')
			);
			event = queryClient.getQueryData<EventType>(queryKeys.eventInstance(alias, shortLocalInstance));
		}
	}

	if (!event) {
		return {
			notFound: true,
		};
	}

	res.setHeader('Cache-Control', `public, max-age=${isBot ? 0 : 5}, s-maxage=${isBot ? 0 : 60 * 60}, stale-while-revalidate=59`);

	return await preloadEventData(event.alias, event.shortLocalInstance, isBot);
};

export default DynamicEventPage;
